module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    免费虚拟主机管理\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "main-area"
  }, [(_vm.num == 1) ? _c('div', [_c('div', {
    staticClass: "operate-panel"
  }, [_c('div', {
    staticClass: "operate-main-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "server-name"
  }, [_c('span', {
    staticStyle: {
      "max-width": "9rem"
    }
  }, [_vm._v(_vm._s(_vm.vhostInfo.ftp_user))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_vm._v("FTP地址：\t" + _vm._s(_vm.vhostInfo.ip) + "（共享）")])]), _vm._v(" "), _c('ul', {
    staticClass: "btn-box"
  }, [_c('li', [_c('a', {
    staticClass: "renew-btn handle-btn",
    on: {
      "click": _vm.Delay
    }
  }, [_vm._v("免费延期")]), _vm._v(" "), _c('span', {
    staticClass: "op-btn-cover"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "more-btn",
    on: {
      "click": function($event) {
        _vm.hide = !_vm.hide
      }
    }
  }, [_c('div', [_vm._v("\n                    更多\n                  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "links-container"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Record
    }
  }, [_c('i', {
    staticClass: "operate-record"
  }), _vm._v(" 延期记录\n                      ")])])])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("FTP账号")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.ftp_user) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("FTP地址")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.ip) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("网站域名")]), _vm._v(" "), _c('a', {
    staticClass: "z-color-a a-underline-link",
    attrs: {
      "href": 'http://' + _vm.vhostInfo.domainname0,
      "target": "_blank"
    }
  }, [_vm._v("http://" + _vm._s(_vm.vhostInfo.domainname0))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("到期时间")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.endtime) + "\n            ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("空间大小")]), _vm._v(" "), _c('span', {
    staticClass: "space-progress relative overflow-hidden",
    attrs: {
      "id": "hostSpace"
    }
  }, [_c('span', {
    staticClass: "use-space absolute progress-bar-success",
    style: ('width: ' + _vm.vhostInfo.websize_bfb + '%')
  })]), _vm._v(" "), _c('span', {
    staticClass: "user-percent-box"
  }, [_c('span', {
    staticClass: "use-space-part",
    staticStyle: {
      "color": "#00aaff"
    },
    attrs: {
      "id": "hostUseSpace"
    }
  }, [_vm._v(_vm._s(_vm.vhostInfo.websize_used))]), _vm._v("/"), _c('span', {
    staticClass: "total-space-part"
  }, [_vm._v(_vm._s(_vm.vhostInfo.websize))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("MySql数据库")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.mysql) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("带宽")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.daikuan) + "（" + _vm._s(_vm.vhostInfo.ip_type) + "）\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("语言环境")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.system) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("MsSql数据库")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.mssql) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("月流量")]), _vm._v("\n              " + _vm._s(_vm.vhostInfo.liuliang) + "\n            ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "box-content out-box-container"
  }, [_c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Domainname
    }
  }, [_c('span', {
    staticClass: "left-icon domain-name"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("域名绑定")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Restart
    }
  }, [_c('span', {
    staticClass: "left-icon restart"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("重启主机")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Defaultset
    }
  }, [_c('span', {
    staticClass: "left-icon default-set"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("默认首页设置")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Errorpage
    }
  }, [_c('span', {
    staticClass: "left-icon error-page"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("404错误页面")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Scriptserror
    }
  }, [_c('span', {
    staticClass: "left-icon scripts-error"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("脚本错误设置")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Redirecturl
    }
  }, [_c('span', {
    staticClass: "left-icon redirect-url"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("301重定向")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Phpselect
    }
  }, [_c('span', {
    staticClass: "left-icon php-select"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("PHP版本设置")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Netselect
    }
  }, [_c('span', {
    staticClass: "left-icon net-select"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v(".NET版本设置")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(5), _vm._v(" "), _c('li', {
    staticClass: "box-content out-box-container"
  }, [_c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Preventchain
    }
  }, [_c('span', {
    staticClass: "left-icon prevent-theft-chain"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("防盗链设置")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Gzip
    }
  }, [_c('span', {
    staticClass: "left-icon gzip"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("压缩解压")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.ConfiemClear
    }
  }, [_c('span', {
    staticClass: "left-icon clear-net"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("清空主机")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Actauth
    }
  }, [_c('span', {
    staticClass: "left-icon act-auth"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("执行权限")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Dirauth
    }
  }, [_c('span', {
    staticClass: "left-icon dir-auth"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("目录权限")])]), _vm._v(" "), _c('a', {
    staticClass: "content-item ",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Blacklist
    }
  }, [_c('span', {
    staticClass: "left-icon domain-name"
  }), _vm._v(" "), _c('span', {
    staticClass: "right-words"
  }, [_vm._v("IP黑白名单")])])])])]) : _vm._e(), _vm._v(" "), (_vm.num == 0) ? _c('div', [_c('x-button', {
    staticStyle: {
      "width": "100px",
      "margin-top": "100px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.vhostInit($event)
      }
    }
  }, [_vm._v("立即开通")])], 1) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "status-circle state-border-success"
  }, [_c('div', {
    staticClass: "product-head-icon host-manage-icon"
  }, [_c('span', {
    staticClass: "text-success",
    attrs: {
      "id": "serverStatus",
      "data-status": "1",
      "data-encode_id": "",
      "data-need_refresh_status": "true"
    }
  }, [_vm._v("运行")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("配置信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("常规管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-warn-master",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('p', [_vm._v("注：服务器升级后，到期时间不变，差价的计算精确到天；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("高级管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc5ca16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/freevhost.vue
// module id = mbSQ
// module chunks = 1